// DO NOT PUT SECRETS IN HERE!!!
const test = {
  flags: {},
  FRONTEND_URL: "https://test-app.read.ai",
  RECORDINGS_URL: "https://test-recordings.read.ai",
  RSS_LINKS_URL: "https://test-cal.read.ai",
  api: {
    HOST: "https://test-api.read.ai",
    disableMetricsQueries: true,
  },
  booking: {
    enableDevRoutes: true,
  },
  tracking: {
    DEBUG: true,
    ENABLED: false,
    GOOGLE_ID: "TEST_GOOGLE_ID",
    MIXPANEL_VERBOSE_LOG: true,
    MIXPANEL_ID: "TEST_MIXPANEL_ID",
    STATSIG_KEY: "TEST_STATSIG_KEY",
  },
  stripe: {
    publishableKey: "TEST_STRIPE_PUBLISHABLE_KEY",
    subscriptionCheckoutReturnUrl:
      "https://test-api.read.ai/billing/checkout-confirm-return",
    creditCheckoutReturnUrl:
      "https://test-api.read.ai/billing/credit-checkout-confirm-return",
    setupReturnUrl: "https://test-api.read.ai/billing/setup-confirm-return",
  },
  billing: {
    zeroBalancePriceIds: ["TEST_READ_FREE_PRICE", "TEST_READ_ZOOM_PRICE"],
    prices: {
      byPriceId: {
        // updated prices
        price_1NuLglKEmPi2JwflT8dFtG1e: 39.75, // monthly enterprise+
        price_1NwtDMKEmPi2JwflOoRsV3Xu: 29.75, // annual enterprise+
        price_1NZz6bKEmPi2JwflxbtLnakM: 29.75, // monthly enterprise
        price_1NZz5mKEmPi2JwflRJmQNiOM: 22.5, // annual enterprise
        price_1NZz85KEmPi2JwflFQyb68bJ: 19.75, // monthly pro
        price_1NZz7nKEmPi2JwflH21Vb6oL: 15, // annual pro
        // legacy prices (do not remove a price from here unless there are 0 active subscriptions with these price ids!)
        price_1M5Gy5KEmPi2Jwfl7Ko3H4im: 25, // monthly enterprise
        price_1MHDQnKEmPi2JwflO9OeJxhg: 16.5, // annual enterprise
        price_1MHDPgKEmPi2JwflclMIvltK: 10, // annual pro
        price_1M5GxKKEmPi2JwflOpKMMBhP: 15, // monthly pro
      } as Record<string, number | undefined>,
    },
    promotions: {
      trial_extension_on_purchase:
        "TEST_PROMOTION_ID_trial_extension_on_purchase",
    },
  },
  apps: {
    teams: {
      AAD_CLIENT_ID: "TEST_TEAMS_AAD_CLIENT_ID",
      APP_ID: "TEST_TEAMS_APP_ID",
    },
    zoom: {
      INSTALL_URL: "https://test-api.read.ai/zoomapp/install",
    },
    meet: {
      CLOUD_PROJECT_NUMBER: "TEST_MEET_CLOUD_PROJECT_NUMBER",
      CLIENT_ID: "TEST_MEET_CLIENT_ID",
    },
  },
  statusMessage: {
    enabled: [],
  },
  // Test key
  recaptchaSite: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
};

export type Config = typeof test;
export default test;
